import React from 'react';
import PropTypes from 'prop-types';
import { getValidationFeedbackClass } from 'utils/formValidations';
import inputStyles from '../purchase/CieloTDCForm/inputStyles';

/**
 * Simple WebView version of CieloTDCFormSelect
 */
const CieloWebViewFormSelect = ({
  id,
  name,
  className = '',
  value = '',
  disabled = false,
  onBlur = () => {},
  onChange = () => {},
  options = [],
  isValid = false,
  hasError = false,
  label = '',
}) => {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#1f2937',
          }}
        >
          {label}
        </label>
      )}
      <select
        id={id}
        name={name}
        className={`${className} ${inputStyles} ${getValidationFeedbackClass(isValid, hasError)}`}
        value={value}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        style={{
          width: '100%',
          padding: '12px 16px',
          fontSize: '16px',
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.display}
          </option>
        ))}
      </select>
    </div>
  );
};

CieloWebViewFormSelect.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.array,
  isValid: PropTypes.bool,
  hasError: PropTypes.bool,
  label: PropTypes.string,
};

export default CieloWebViewFormSelect;
